import { render, staticRenderFns } from "./TiersHome.vue?vue&type=template&id=02092fd9&"
import script from "./TiersHome.vue?vue&type=script&lang=js&"
export * from "./TiersHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports